import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';
import { GTMAnalytics } from '~services/analytics';
import { updateRegistrationMarkersAsync } from '~shared/api/origin/analytics/registration';

export const updateUserRegistrationInfo = async ({
	data,
	userId,
}: {
	data: Record<string, string>;
	userId: string;
}): Promise<void> => {
	try {
		GTMAnalytics.annalsRegistrationPromise = Promise.resolve(data);
		await updateRegistrationMarkersAsync({ userId, data });
	} catch (error) {
		ClientLogger.error(
			LoggerServices.AnnalsService,
			LoggerMessages.AnnalsSentRegistrationEventError,
			{}
		);
	}
};
